"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TableStepsDefaultProps = exports.TableSteps = void 0;

var _tableSteps = _interopRequireDefault(require("./components/table-steps"));

exports.TableSteps = _tableSteps["default"];

var _tableSteps2 = _interopRequireDefault(require("./components/table-steps.props/table-steps.defaultProps"));

exports.TableStepsDefaultProps = _tableSteps2["default"];